<dtm-map-html-cesium-component *ngIf="selectedResultPosition$ | ngrxPush as position" [coordinates]="position">
    <img alt="" src="assets/images/search-result-pin.svg" />
</dtm-map-html-cesium-component>
